import { Flex, Form, Typography } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import {
  getTeamGroups,
  getTeamUsers,
  getUserGroupByTeam,
  getWorkList,
} from '../../api/aops.api'
import AopsHeader from '../../components/apos/AopsHeader'
import SectionHeader from '../../components/apos/SectionHeader'
import { userAuthStatus, userState } from '../../store/user'
import '../electricApproval/electricApproval.scss'
// import FastLaneBoard from './FastLaneBoard'
import { getAgileBoard } from '../../api/aops.api'
import { isAopsChiefState, menuSelectedTeam } from '../../store/aops'
import BoardWorkPopup from './BoardWorkPopup'
import FastLaneBoard from './FastLaneBoard'
import KanbanBoard from './KanbanBoard'
import ObjectiveDetailPopup from './ObjectiveDetailPopup'
import ResponseBoard from './ResponseBoard'
import ScrumBoard from './ScrumBoard'
import './fastLaneBoard.scss'
const { Text, Title } = Typography

const mapPriorityToFrontendColor = (priority) => {
  switch (priority) {
    case 'FIRST':
      return '#FF7853'
    case 'SECOND':
      return '#FFCA00'
    case 'THIRD':
      return '#1FC297'
    default:
      return ''
  }
}
const SchedulePage = () => {
  const { team } = useParams()
  const [form] = Form.useForm()
  const [user] = useRecoilState(userState)
  const [userAuth, setUserAuth] = useRecoilState(userAuthStatus)
  // const [se]
  const [teamUsers, setTeamUsers] = useState([])
  // 핵심 데이터 상태
  const [tasks, setTasks] = useState([])
  const [nowEpics, setNowEpics] = useState([])
  const [representativeEpic, setRepresentativeEpic] = useState([])
  const [isUserInGroup, setIsUserInGroup] = useState(false)
  const [selectedTeamByMenu] = useRecoilState(menuSelectedTeam)
  // 계층 및 필터 상태
  const [selectedStudio, setSelectedStudio] = useState(null)
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [activeLevel, setActiveLevel] = useState('MEMBER') // 초기값 TEAM
  const [selectedMember, setSelectedMember] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedTask, setSelectedTask] = useState(null)
  const [fastLaneList, setFastLaneList] = useState([])
  const [agileBoardData, setAgileBoardData] = useState(null)
  const [workDetail, setWorkDetail] = useState(null)
  const [selectedStudioKo, setSelectedStudioKo] = useState(null)
  const [selectedTeamKo, setSelectedTeamKo] = useState(null)
  const showCreateButton = activeLevel !== 'MEMBER'
  const [isInitiativeModalOpen, setIsInitiativeModalOpen] = useState(false)
  const [isChief] = useRecoilState(isAopsChiefState)

  const finalSelectedMemberId = selectedMember?.id || user.id
  const createType =
    activeLevel === 'STUDIO'
      ? 'EPIC'
      : activeLevel === 'TEAM'
        ? 'STORY'
        : 'TASK'

  // selectedTeamByMenu가 설정되었는지 추적
  const [hasTeamMenuSelected, setHasTeamMenuSelected] = useState(false)

  // selectedTeamByMenu가 설정되면 플래그 설정
  useEffect(() => {
    if (selectedTeamByMenu) {
      setHasTeamMenuSelected(true)
    }
  }, [selectedTeamByMenu])

  // activeLevel과 selectedTeamByMenu가 모두 준비된 후에만 initData 호출
  useEffect(() => {
    // selectedTeamByMenu가 설정되고, activeLevel이 초기값이 아닌 경우에만 실행
    if (
      team &&
      finalSelectedMemberId &&
      hasTeamMenuSelected &&
      selectedTeamByMenu
    ) {
      initData()
      console.log('activeLevel', activeLevel)
      console.log('finalSelectedMemberId', finalSelectedMemberId)
      console.log('selectedTeamByMenu', selectedTeamByMenu)
    }
  }, [
    team,
    activeLevel,
    selectedMember,
    finalSelectedMemberId,
    hasTeamMenuSelected,
    selectedTeamByMenu,
  ])

  // SchedulePage.jsx 상단 상태 추가
  const [popupTargetType, setPopupTargetType] = useState(null) // 'EPIC', 'STORY', 'TASK' 중 하나
  // ObjectiveDetailPopup에 표시할 objective 상태 (스택 유지를 위해 별도 관리)
  const [selectedObjectiveForDetail, setSelectedObjectiveForDetail] =
    useState(null)
  // ScrumBoard의 InitiativeBoardWorkPopup이 열려있는지 추적 (Task 팝업 z-index 계산용)
  const [isScrumInitiativePopupOpen, setIsScrumInitiativePopupOpen] =
    useState(false)

  // 공통 열기 핸들러
  const openPopup = (type, task = null) => {
    // EPIC 타입이면 ObjectiveDetailPopup으로 처리
    if (type === 'EPIC' && task) {
      // agileBoardData.objectives에서 찾기 시도
      let objective = agileBoardData?.objectives?.find(
        (o) => o.id === (task?.worksInfoDto?.id ?? task?.id),
      )
      // 찾지 못하면 (Done/On hold 등) task 정보로 기본 objective 생성
      if (!objective) {
        objective = {
          id: task?.worksInfoDto?.id ?? task?.id,
          title: task?.worksInfoDto?.title ?? '',
          sequence: task?.worksInfoDto?.sequence ?? 1,
          initiativesByCategory: {}, // 빈 카테고리
        }
      }
      // ObjectiveDetailPopup 열기
      setSelectedObjectiveForDetail(objective)
      setSelectedTask(task)
      setIsModalOpen(true)
      // popupTargetType은 설정하지 않음 (BoardWorkPopup이 열리지 않도록)
      return
    }

    // 일반 카드(STORY/TASK)
    setPopupTargetType(type)
    setSelectedTask(task)
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setSelectedTask(null)
    setPopupTargetType(null) // 타입 초기화
    form.resetFields()
    setIsInitiativeModalOpen(false)
    onReloadList()
  }
  // console.log('selectedTeamByMenu', selectedTeamByMenu)
  // --------------------------
  // -------------김태희 추가 2026-01-28 시작 🔥 -------------
  // --------------------------
  const fetchTeamGroups = async () => {
    const res = await getTeamGroups()
    // setTeamInfoList(res.data)
    const selectedTeamGroup = res.find(
      (item) => item.name === selectedTeamByMenu,
    )
    if (selectedTeamGroup?.id !== null) {
      fetchTeamUsers(selectedTeamGroup.id)
    }
  }

  const fetchTeamUsers = async (teamGroupId) => {
    if (teamGroupId === null) return
    const res = await getTeamUsers(teamGroupId)
    const userList = res.map((item) => ({
      id: item.id,
      name: item.name,
      email: item.email,
    }))
    setTeamUsers(userList)
  }

  const isMyTeam = selectedTeamByMenu === userAuth?.teamName

  useEffect(() => {
    // selectedTeamByMenu가 설정되고, isChief와 userAuth가 준비된 후에만 activeLevel 설정
    if (selectedTeamByMenu && isChief !== undefined && userAuth) {
      setSelectedMember(null)
      const currentIsMyTeam = selectedTeamByMenu === userAuth?.teamName
      if (isChief) {
        // chief면 무조건 STUDIO, 개인 선택 안 함
        setActiveLevel('STUDIO')
      } else if (!currentIsMyTeam) {
        // 내 팀이 아니면 TEAM 레벨만 선택, 개인은 선택 안 함
        setActiveLevel('TEAM')
      } else {
        setActiveLevel('MEMBER')
      }
      fetchTeamGroups()
    }
  }, [selectedTeamByMenu, isChief, userAuth])

  // 내 팀이고 isChief가 아닐 때만 자신의 정보로 자동 선택
  useEffect(() => {
    if (isMyTeam && !isChief && teamUsers.length > 0 && user) {
      const currentUser = teamUsers.find((u) => u.id === user.id)
      if (currentUser) {
        setSelectedMember(currentUser)
      } else if (user.id) {
        setSelectedMember({
          id: user.id,
          name: user.name || user.userName,
        })
      }
    }
  }, [isMyTeam, teamUsers, isChief, user])
  // --------------------------
  // -------------김태희 추가 2026-01-28 끝🔥 -------------
  // --------------------------
  const onReloadList = () => {
    // console.log('onReloadList')
    initData()
    fetchAgileBoard()
  }

  const initData = async () => {
    try {
      const res = await getUserGroupByTeam({ teamName: team })
      const studio = res.data.studio
      setSelectedStudio(studio)
      setSelectedTeam(res.data.team)
      setSelectedStudioKo(res.data.studioKo)
      setSelectedTeamKo(res.data.teamKo)

      const workListRes = await getWorkList({
        salusUserId: finalSelectedMemberId,
        workType: createType,
        studioName: studio,
        teamName: team,
      })

      // [수정] DTO 구조에 맞춰 안전하게 꺼내오기
      const {
        works = [],
        nowEpics = [],
        isUserInGroup: inGroup = false,
        representativeEpic = [],
      } = workListRes.data

      // console.log('workListRes', workListRes)

      // [수정] work가 WorkListItemDto 형태이므로 내부 worksInfoDto를 참조해야 함
      const mappedWorks = works.map((work) => {
        const info = work.worksInfoDto // 내부 핵심 정보 추출

        return {
          ...work, // storyChildProblemCount 등 새로운 필드 유지
          status: mapBackendStateToFrontend(info?.progressState),
          dateRange: info
            ? `${dayjs(info.startDateTime).format('YY년 MM월 DD일')} - ${dayjs(info.endDateTime).format('YY년 MM월 DD일')}`
            : '',
          hasIssue: info?.hasProblem || false,
        }
      })

      setTasks(mappedWorks)
      setNowEpics(nowEpics)
      setIsUserInGroup(inGroup)
      setRepresentativeEpic(representativeEpic) // 이제 객체 배열(id, title, priority)임
    } catch (error) {
      console.error('데이터 로딩 중 오류 발생:', error)
      setTasks([])
    }
  }

  const mapBackendStateToFrontend = (progressState) => {
    switch (progressState) {
      case 'TODO':
        return 'To Do List'
      case 'IN_PROGRESS':
        return 'In Progress'
      case 'IN_REVIEW':
        return 'In Review'
      case 'DONE':
        return 'Done'
      case 'ON_HOLD':
        return 'On hold'
      default:
        return progressState
    }
  }

  const getButtonText = () => {
    if (showCreateButton && isUserInGroup) {
      if (createType === 'STORY') {
        return 'Initiative 업무 생성'
      } else if (createType === 'EPIC') {
        return 'Objective 업무 생성'
      }
    } else {
      return ''
    }
  }

  const fetchAgileBoard = async () => {
    const res = await getAgileBoard(selectedStudio, user.id)
    console.log('getAgileBoard res = ', res)
    setAgileBoardData(res.data)
  }

  const CATEGORY_MAP = {
    IMPROVEMENT: '개선',
    NEW_FEATURE: '신규',
    POLICY_STANDARD: '정책/기준',
    INCIDENT_RESPONSE: '사고 대응',
    ETC: '기타',
  }

  /**
   * API 데이터를 컴포넌트용 포맷으로 변환
   */
  const transformInitiatives = (initiativesByCategory) => {
    const transformed = {}
    Object.entries(initiativesByCategory).forEach(([key, value]) => {
      const koreanKey = CATEGORY_MAP[key]
      if (koreanKey) {
        transformed[koreanKey] = value
      }
    })
    return transformed
  }

  useEffect(() => {
    if (selectedStudio) {
      fetchAgileBoard()
    }
  }, [selectedStudio])

  // EPIC 카드 클릭 시: agileBoardData에서 해당 objective를 찾아 ObjectiveDetailPopup으로 표시
  const resolvedObjectiveForDetail =
    createType === 'EPIC' &&
    isModalOpen &&
    selectedTask &&
    !selectedObjectiveForDetail && // 이미 열려있으면 재계산하지 않음
    agileBoardData?.objectives?.find(
      (o) => o.id === (selectedTask?.worksInfoDto?.id ?? selectedTask?.id),
    )

  // resolvedObjectiveForDetail이 계산되면 selectedObjectiveForDetail에 저장 (스택 유지)
  useEffect(() => {
    if (resolvedObjectiveForDetail) {
      setSelectedObjectiveForDetail(resolvedObjectiveForDetail)
    }
  }, [resolvedObjectiveForDetail])

  return (
    <div
      style={{
        background: '#f9fafb',
        minHeight: '100vh',
        paddingBottom: '60px',
      }}
    >
      {/* 1. 최상단 경로 및 토글 버튼 영역 */}
      <AopsHeader active="schedule" />

      <section className="electric-approval-container">
        {/* 2. 칸반 보드 섹션 (내부에 업무 생성 버튼 포함) */}

        <div style={{ marginBottom: '40px' }}>
          <SectionHeader
            title="Agile 보드"
            subtitle="지금 할 일은 In Progress로, 끝난 일은 Done으로 완료 처리해주세요"
            buttonText={getButtonText()}
            onButtonClick={() => {
              if (showCreateButton && isUserInGroup) {
                openPopup(createType)
              }
            }}
          />
          <KanbanBoard
            team={team}
            user={user}
            tasks={tasks}
            activeLevel={activeLevel}
            setActiveLevel={setActiveLevel}
            selectedMember={selectedMember}
            setSelectedMember={setSelectedMember}
            representativeEpic={representativeEpic}
            selectedStudio={selectedStudio}
            selectedTeam={selectedTeam}
            createType={createType}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedTask={selectedTask}
            setSelectedTask={setSelectedTask}
            workDetail={workDetail}
            setWorkDetail={setWorkDetail}
            onReloadList={onReloadList}
            isUserInGroup={isUserInGroup}
            selectedStudioKo={selectedStudioKo}
            selectedTeamKo={selectedTeamKo}
            teamUsers={teamUsers}
            isChief={isChief}
            finalSelectedMemberId={finalSelectedMemberId}
            isMyTeam={isMyTeam}
            onOpenPopup={openPopup}
          />
        </div>
        {/* 2. 패스트 레인 보드 */}
        {activeLevel === 'MEMBER' && userAuth.teamName === selectedTeam && (
          <Flex
            gap={12}
            style={{ width: '100%', marginBottom: '40px' }}
            className="fast-lane-board-container"
          >
            <div
              style={{ width: `calc(50% - 6px)` }}
              className="fast-lane-board-item"
            >
              <FastLaneBoard
                onReloadInitData={onReloadList}
                setFastLaneList={setFastLaneList}
                fastLaneList={fastLaneList}
                userId={finalSelectedMemberId}
                myId={user.id}
              />
            </div>
            <div
              style={{ width: `calc(50% - 6px)` }}
              className="fast-lane-board-item"
            >
              <ResponseBoard
                onReloadInitData={onReloadList}
                setFastLaneList={setFastLaneList}
                fastLaneList={fastLaneList}
                userId={finalSelectedMemberId}
                myId={user.id}
              />
            </div>
          </Flex>
        )}
        {/* 3. 스크럼 보드 섹션 */}
        <div>
          <SectionHeader
            title="Scrum 보드"
            subtitle="오늘 해야 할 일을 명확히 하고 하나씩 완료해 나가세요"
            buttonText={''}
            onButtonClick={null}
          />
          <ScrumBoard
            tasks={tasks}
            activeLevel={activeLevel}
            createType={createType}
            selectedTeam={selectedTeam}
            onReloadList={onReloadList}
            userId={finalSelectedMemberId}
            onTaskClick={(task) => {
              openPopup('TASK', task)
            }}
            agileBoardData={agileBoardData}
            transformInitiatives={transformInitiatives}
            showCreateButton={showCreateButton}
            onOpenStoryPopup={(task) => openPopup('STORY', task)}
            onOpenStoryCreate={() => openPopup('STORY')}
            onInitiativePopupOpenChange={setIsScrumInitiativePopupOpen}
          />
        </div>
        <BoardWorkPopup
          open={isModalOpen && popupTargetType !== null}
          onClose={handleCancel}
          zIndex={
            isScrumInitiativePopupOpen
              ? 1200
              : selectedObjectiveForDetail
                ? 1100
                : undefined
          } // InitiativeBoardWorkPopup(1050/1100) 위에 표시, ObjectiveDetailPopup(1000) 위에 표시
          // 부모에서 명시적으로 지정한 타입을 우선 사용
          type={popupTargetType || createType}
          id={selectedTask?.worksInfoDto?.id || selectedTask?.id}
          task={selectedTask}
          createType={createType} // 현재 페이지 모드 유지용
          selectedTeam={selectedTeam}
          parentStartDateTime={selectedTask?.taskDetails?.parentStartDateTime}
          parentEndDateTime={selectedTask?.taskDetails?.parentEndDateTime}
        />
        <ObjectiveDetailPopup
          open={!!selectedObjectiveForDetail}
          onClose={() => {
            setSelectedObjectiveForDetail(null) // ObjectiveDetailPopup 닫기
            setIsModalOpen(false)
            setSelectedTask(null)
            setPopupTargetType(null)
            onReloadList()
          }}
          objective={selectedObjectiveForDetail ?? null}
          objectiveNumber={
            selectedObjectiveForDetail
              ? String(selectedObjectiveForDetail.sequence ?? 1).padStart(
                  2,
                  '0',
                )
              : '01'
          }
          objectiveTitle={selectedObjectiveForDetail?.title ?? ''}
          tasksByCategory={transformInitiatives(
            selectedObjectiveForDetail?.initiativesByCategory ?? {},
          )}
          onTaskClick={(task) => openPopup('STORY', task)}
          onCreateClick={() => openPopup('STORY')}
          onObjectiveClick={(obj) => {
            // "상세 보기" 클릭 시: ObjectiveDetailPopup은 유지하고 BoardWorkPopup만 열기
            setPopupTargetType('EPIC')
            setSelectedTask({
              worksInfoDto: { id: obj.id, title: obj.title },
              id: obj.id,
            })
            setIsModalOpen(true) // BoardWorkPopup 열기 (ObjectiveDetailPopup은 그대로 유지)
          }}
          showCreateButton={showCreateButton}
        />
      </section>
    </div>
  )
}

const getButtonStyle = (isActive) => ({
  borderRadius: '100px',
  background: isActive ? '#000000' : '#fff',
  color: isActive ? '#fff' : '#383E44',
  border: isActive ? 'none' : '1px solid #E2EAEF',
  fontSize: '16px',
  height: '40px',
  padding: '0 20px',
  fontWeight: isActive ? '700' : '600',
})
// 공통 스타일링 변수들
const labelStyle = {
  fontSize: '16px',
  display: 'block',
  marginBottom: '12px',
  fontWeight: '500',
  color: '#585f65',
}
const epicBadgeStyle = {
  position: 'relative',
  background: '#F6F7FA',
  border: '1px solid #E2EAEF',
  padding: '12px 16px 12px 24px',
  height: '40px',
  borderRadius: '8px',
  width: '300px',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
}
const priorityStripStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  width: '6px',
}
const epicTextStyle = {
  color: '#191A1C',
  width: '100%',
  textAlign: 'left',
  fontWeight: '600',
}

export default SchedulePage
